<script setup lang="ts">
import BaseAutoCompleteWithSingleSelectedItem from "@/components/AutoCompletes/BaseAutoCompleteWithSingleSelectedItem.vue"
import FormRow from "@/components/Common/FormRow.vue"
import getRole from "@/types/responses/getRole"
import { computed } from "vue"
import i18n from "@/lang/i18n"

const emit = defineEmits(['update:modelValue'])
const props = defineProps<{
  roles: getRole[]
  modelValue: getRole | null
  windowInnerWidth: number
  errorMessages: string[]
}>()

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
})
</script>
<template>
  <FormRow
    :title="i18n.global.t('pages.roleAssignment.form.roleName')"
    :windowInnerWidth="props.windowInnerWidth"
    :required="true"
  >
    <div style="width: 40%">
      <BaseAutoCompleteWithSingleSelectedItem
        v-model="modelValue"
        itemName="display_name"
        :items="props.roles"
        :errorMessages="props.errorMessages"
      />
    </div>
  </FormRow>
</template>